export const getGlobalInstance = <T>(key: string): T => {
    return window.globalInstances?.[key] || undefined
}
